// extracted by mini-css-extract-plugin
export default {"processStepName":"processStepName-PdG_J","instrumentName":"instrumentName-fQs55","commandName":"commandName-yfq1T"};